import script from "./NewMyProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./NewMyProfile.vue?vue&type=script&setup=true&lang=js"

import "./NewMyProfile.vue?vue&type=style&index=0&id=1c6707a0&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c6707a0"]])

export default __exports__